<template>
    <p
        v-if="value"
        v-html="value"
        class="title font-weight-light short-description mt-2"
    ></p>
</template>

<style scoped>
.short-description {
    margin-bottom: 0;
}
.short-description p {
    margin-bottom: 0;
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex';

const parentModuleName = 'Product';
const { mapState, mapGetters } = createNamespacedHelpers(parentModuleName);

export default {
    name: 'ProductShortDescription',
    computed: {
        value() {
            return this.getProductAttributeByLanguage(this.product, 'product.description.short');
        },
        ...mapState(['product']),
        ...mapGetters(['getProductAttributeByLanguage'])
    },
};
</script>